enum ScrollDirections {
  SCROLL_UP = 'up',
  SCROLL_DOWN = 'down',
}

export default ScrollDirections;
